import { Component, OnInit, Inject, ViewChild } from "@angular/core";
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from "@angular/common/http";
import { ApiService } from "../../../api.service";
import { ActivatedRoute, Router } from "@angular/router";
import { environment } from "../../../../environments/environment";
import { ToastService } from "@app/components/toastr/toast.service";
import { LocalDataSource } from "ng2-smart-table";

@Component({
  selector: "app-stream-list",
  templateUrl: "./stream-list.component.html",
  styleUrls: ["./stream-list.component.scss"],
})
export class StreamListComponent implements OnInit {
 
  message = null;
  class = null;
  public list = new LocalDataSource();
  constructor(
    private router: Router,
    private api: ApiService,
    private http: HttpClient,
    private toast: ToastService,
    @Inject("API_ENDPOINT") private api_endpoint: string
  ) { }

  public settings = {
    actions: {
      position: "right",
      add: false,
      edit: false,
      delete: true,
    },
    delete: {
      confirmDelete: true,
    },
    columns: {
      name: {
        title: "Stream",
      },
      _id: {
        title: "Edit",
        type: "html",
        valuePrepareFunction: (cell, row) => {
          return `<a href="stream/edit/${row._id}"  class="ng2-smart-action ng2-smart-action-edit-edit ng-star-inserted"><i class="fa fa-pencil"></i></a>&nbsp; `;
        },
        filter: false,
      },
    },
  };

  ngOnInit() {
    this.http
      .get<any>(`${environment.apiUrl}/streams/`, {
        headers: {
          Userinfo: JSON.stringify({
            _id: localStorage.getItem("adminSess"),
            role: localStorage.getItem("userRole"),
          }),
        },
      })
      .subscribe(
        (data) => {
           if (data.message == "Logged Out!") {
      this.router.navigateByUrl("/auth/login");
    } else {
      this.list.load(data.results);   // ✅ load into source
    }

        },
        (err: HttpErrorResponse) => {
          if (err.error instanceof Error) {
            console.log("Client-side error occured.");
          } else {
            console.log("Server-side error occured.");
          }
        }
      );
  }

 deleteRecord(event) {
  if (confirm("Are You Sure?")) {
    const adminSess = localStorage.getItem("adminSess");
    const userRole = localStorage.getItem("userRole");

    if (!adminSess || !userRole) {
      this.toast.show("Authentication data missing. Please login again.", "error");
      this.router.navigateByUrl("/auth/login");
      event.confirm.reject();
      return;
    }

    const headers = new HttpHeaders({
      'Userinfo': JSON.stringify({ _id: adminSess, role: userRole })
    });

    this.http.delete<any>(`${environment.apiUrl}/streams/${event.data._id}`, { headers })
      .subscribe(
        (res) => {
          if (res.message === "Logged Out!" || res.status === 403) {
            this.toast.show("Session expired. Please login again.", "error");
            this.router.navigateByUrl("/auth/login");
            event.confirm.reject();
            return;
          }

          if (res.status === 500) {
            this.toast.show(res.message || "Failed to delete stream", "error");
            event.confirm.reject();
          } else {
            // ✅ tell smart-table deletion succeeded
            event.confirm.resolve();

            // ✅ show toast
            this.toast.show("Successfully Deleted", "success");
          }
        },
        (err: HttpErrorResponse) => {
          console.error("Error deleting stream:", err);

          if (err.status === 403) {
            this.toast.show("Permission denied. You don't have access to delete streams.", "error");
            this.router.navigateByUrl("/auth/login");
          } else if (err.status === 401) {
            this.toast.show("Session expired. Please login again.", "error");
            this.router.navigateByUrl("/auth/login");
          } else {
            this.toast.show("Server error occurred while deleting", "error");
          }

          event.confirm.reject();
        }
      );
  } else {
    event.confirm.reject();
  }
}





}
